export default "__VITE_ASSET__Dss40xHx__"